/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e=e=>e.split(/(?=[A-Z])/).map(((e,o)=>0===o?`${e.charAt(0).toUpperCase()}${e.slice(1)}`:e.toLowerCase())).join(" ");export{e as camelCaseToHumanCase};
//# sourceMappingURL=camelCaseToHumanCase.js.map
